var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chatbot-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-Default",
    transform: "translate(-1350.000000, -764.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(1349.999752, 763.999876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,31 C0,48.12192 13.87932,62 31,62 C48.12068,62 62,48.12192 62,31 C62,13.87932 48.12068,0 31,0 C13.87932,0 0,13.87932 0,31",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.96,44.700636 L27.93596,53.478596 C27.218,54.201516 25.98296,53.693116 25.98296,52.672596 L25.98296,44.700636 L23.56,44.700636 L18.0358,44.700636 C16.6036,44.700636 15.44296,43.539996 15.44296,42.107796 L15.44296,17.952596 C15.44296,16.520396 16.6036,15.359756 18.0358,15.359756 L43.96544,15.359756 C45.39764,15.359756 46.55828,16.520396 46.55828,17.952596 L46.55828,42.107796 C46.55828,43.539996 45.39764,44.700636 43.96544,44.700636 L37.12808,44.700636 L35.96,44.700636 Z",
    id: "Fill-4",
    fill: "#FFB92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.06,27.139632 C37.69228,27.139632 36.58,28.251912 36.58,29.619632 C36.58,30.987352 37.69228,32.099632 39.06,32.099632 C40.42772,32.099632 41.54,30.987352 41.54,29.619632 C41.54,28.251912 40.42772,27.139632 39.06,27.139632",
    id: "Fill-6",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.38,27.139632 C29.01228,27.139632 27.9,28.251912 27.9,29.619632 C27.9,30.987352 29.01228,32.099632 30.38,32.099632 C31.74772,32.099632 32.86,30.987352 32.86,29.619632 C32.86,28.251912 31.74772,27.139632 30.38,27.139632",
    id: "Fill-10",
    fill: "#000000"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotIcon);
export default __webpack_public_path__ + "static/media/chatbot_icon.f61da2e4.svg";
export { ForwardRef as ReactComponent };